export default "__VITE_ASSET__DnjnsDUE__"